import { gtag } from "../gtag.mjs";
export function useGtag() {
  if (process.server)
    return () => {
    };
  return gtag;
}
